export const londonCoordinates: Record<string, { lat: number; lng: number }> = {
  // Day 1 — Arrival & Covent Garden
  'Southampton Row, Holborn': { lat: 51.5188, lng: -0.1208 },
  'Covent Garden Piazza': { lat: 51.5117, lng: -0.124 },
  '1 Aldwych, Covent Garden': { lat: 51.5126, lng: -0.117 },

  // Day 2 — Victoria Park, Museums & Expo
  'Victoria Park, Bow': { lat: 51.5373, lng: -0.0395 },
  'Cromwell Road, South Kensington': { lat: 51.4966, lng: -0.1764 },
  'Borough Market, Southwark': { lat: 51.5055, lng: -0.0911 },
  'ExCeL London, Royal Victoria Dock': { lat: 51.5085, lng: 0.0291 },
  '65 Commercial Street, Spitalfields': { lat: 51.5195, lng: -0.0758 },

  // Day 3 — Embankment run & hop-on/hop-off
  'Westminster Bridge': { lat: 51.5007, lng: -0.1218 },
  'Victoria Embankment': { lat: 51.5074, lng: -0.1183 },

  // Day 4 — Taper & Theatre
  'Duchess Theatre, Catherine Street': { lat: 51.5126, lng: -0.1192 },

  // Day 5 — Race Day
  'Blackheath, Greenwich': { lat: 51.4663, lng: 0.0086 },
  'The Mall, Westminster': { lat: 51.5024, lng: -0.1408 },

  // Day 6 — Recovery, British Museum, Square Pig & Duke of York
  'Great Russell Street, Bloomsbury': { lat: 51.5194, lng: -0.127 },
  'Procter Street, Holborn': { lat: 51.5188, lng: -0.1191 },
  '42 Mays Lane, Barnet': { lat: 51.653, lng: -0.193 },
  'Dancers Hill Road, Potters Bar': { lat: 51.6815, lng: -0.1871 },

  // Day 7 — Barnet & St Albans
  'The Spires Shopping Centre, High Barnet': { lat: 51.6552, lng: -0.2021 },
  '10 Union Street, Barnet': { lat: 51.6555, lng: -0.2033 },
  '7-8 Christopher Place, St Albans': { lat: 51.7516, lng: -0.3372 },
  'St Albans Cathedral': { lat: 51.7505, lng: -0.3426 },
  'Galley Lane, Barnet': { lat: 51.6628, lng: -0.2285 },

  // Day 8 — North London
  'Camden High Street': { lat: 51.5413, lng: -0.147 },
  "Regent's Park": { lat: 51.5313, lng: -0.157 },
  'Holly Mount, Hampstead': { lat: 51.5584, lng: -0.1782 },
  "St George's Circus, Southwark": { lat: 51.499, lng: -0.104 },

  // Day 9 — Tower & East
  'Tower of London, Tower Hill': { lat: 51.5081, lng: -0.0759 },
  'Tower Bridge': { lat: 51.5055, lng: -0.0754 },
  '32 London Bridge Street': { lat: 51.5045, lng: -0.0865 },
  '100 Liverpool Street, City': { lat: 51.5178, lng: -0.0823 },

  // Day 10 — Departure
  'Stoney Street, Borough Market': { lat: 51.5053, lng: -0.0907 },
};

export const londonCenter = { lat: 51.5074, lng: -0.1278 };
